import { Router, NavigationEnd } from "@angular/router";
import { DOCUMENT } from "@angular/common";
import {
  Component,
  Inject,
  ElementRef,
  OnInit,
  Renderer2,
  HostListener,
  OnDestroy,
} from "@angular/core";
import { ROUTES } from "./sidebar-items";
import { AuthService } from "src/app/shared/services/auth.service";
import { Role } from "src/app/shared/models/role";
import {Usuario} from "../../../models/usuario.model";
import {SecurityService} from "../../../services/security.service";
import {takeUntil} from "rxjs/operators";
import {EmpresaEntity} from "../../../entity/empresa.entity";
import {AppSesionStore} from "../../../../data/datasource/store/app.sesion-store";
import {Subject} from "rxjs";
import {environment} from "../../../../../environments/environment";
@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.sass"],
})
export class SidebarComponent implements OnInit, OnDestroy {
  public sidebarItems: any[];
  level1Menu = "";
  level2Menu = "";
  level3Menu = "";
  public innerHeight: any;
  public bodyTag: any;
  listMaxHeight: string;
  listMaxWidth: string;
  userFullName: string;
  static readonly IMAGEN_POR_DEFECTO = "assets/images/user/admin.png";
  userImg: string;
  userType: string;
  headerHeight = 60;
  manualHeight = 48;
  // el manual se publica con el backend (asistenciaapi/docs/manual)
  manualUrl = environment.CDN_BASE + 'docs/manual/index.php';
  currentRoute: string;
  routerObj = null;

  public usuarioLogeado: Usuario;

  empresaObj = this.securityService.empresaSession();
  private unsubscribe$ = new Subject();

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
    public elementRef: ElementRef,
    private authService: AuthService,
    private router: Router,
    private securityService: SecurityService,
    public appStore: AppSesionStore
  ) {
    const body = this.elementRef.nativeElement.closest("body");
    this.routerObj = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // logic for select active menu in dropdown
        const role = ["admin", "doctor", "patient"];
        const currenturl = event.url.split("?")[0];
        const firstString = currenturl.split("/").slice(1)[0];

        if (role.indexOf(firstString) !== -1) {
          this.level1Menu = event.url.split("/")[2];
          this.level2Menu = event.url.split("/")[3];
        } else {
          this.level1Menu = event.url.split("/")[1];
          this.level2Menu = event.url.split("/")[2];
        }
        // el menu agrupa pantallas de rutas distintas: se abre el grupo que contiene la pantalla actual
        this.abrirGrupoDe(currenturl);

        // close sidebar on mobile screen after menu select
        this.renderer.removeClass(this.document.body, "overlay-open");
      }
    });

    this.appStore.currentEmpresaSesion$.pipe(takeUntil(this.unsubscribe$)).subscribe( (currentEmpresa:EmpresaEntity) => {
      if (currentEmpresa){
        this.empresaObj = currentEmpresa;
        this.updateUrlImg();
      }
    });
  }


  @HostListener("window:resize", ["$event"])
  windowResizecall(event) {
    this.setMenuHeight();
    this.checkStatuForResize(false);
  }
  @HostListener("document:mousedown", ["$event"])
  onGlobalClick(event): void {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.renderer.removeClass(this.document.body, "overlay-open");
    }
  }
  /** Deja desplegados el modulo y el submenu que contienen la ruta actual. */
  private abrirGrupoDe(url: string) {
    const contiene = (item: any) => !!item.path && item.path !== '/' && item.submenu.length === 0
        && (url === item.path || url.startsWith(item.path + '/'));
    for (const modulo of (this.sidebarItems || [])) {
      for (const sub of modulo.submenu) {
        if (contiene(sub)) {
          this.level1Menu = modulo.moduleName;
          this.level2Menu = sub.moduleName;
          return;
        }
        if (sub.submenu.some(contiene)) {
          this.level1Menu = modulo.moduleName;
          this.level2Menu = sub.moduleName;
          return;
        }
      }
    }
  }

  callLevel1Toggle(event: any, element: any) {
    if (element === this.level1Menu) {
      this.level1Menu = "0";
    } else {
      this.level1Menu = element;
    }
    const hasClass = event.target.classList.contains("toggled");
    if (hasClass) {
      this.renderer.removeClass(event.target, "toggled");
    } else {
      this.renderer.addClass(event.target, "toggled");
    }
  }
  callLevel2Toggle(event: any, element: any) {
    if (element === this.level2Menu) {
      this.level2Menu = "0";
    } else {
      this.level2Menu = element;
    }
  }
  callLevel3Toggle(event: any, element: any) {
    if (element === this.level3Menu) {
      this.level3Menu = "0";
    } else {
      this.level3Menu = element;
    }
  }
  ngOnInit() {
    if (true) {

      this.usuarioLogeado = this.securityService.usuarioLogeado();

      const userRole = Role.Admin;
      this.userFullName = this.usuarioLogeado.getUsuario_nombres() + " " + this.usuarioLogeado.getUsuario_apellidos();

      this.updateUrlImg();

      const cargoUsuario = this.usuarioLogeado.getUsuario_cargo();

      this.sidebarItems = ROUTES.filter(
        (x) => (x.role.indexOf(cargoUsuario) !== -1 || x.role.indexOf("All") !== -1) &&
            this.securityService.checkPermission(x.permissionList)
      );

      const visible = (x) => (x.role.indexOf(cargoUsuario) !== -1 || x.role.indexOf("All") !== -1) &&
          this.securityService.checkPermission(x.permissionList);
      for (const data of this.sidebarItems) {
        // segundo y tercer nivel; un submenu que se queda sin opciones visibles no se muestra
        data.submenu = data.submenu.filter(visible)
            .map(sub => ({...sub, submenu: sub.submenu.filter(visible)}))
            .filter(sub => sub.class !== 'ml-sub-menu' || sub.submenu.length > 0);
      }
      this.sidebarItems = this.sidebarItems.filter(x => x.class !== 'menu-toggle' || x.submenu.length > 0);



      this.userType = this.usuarioLogeado.getUsuario_cargotext();
    }


    this.abrirGrupoDe(this.router.url.split("?")[0]);
    // this.sidebarItems = ROUTES.filter((sidebarItem) => sidebarItem);
    this.initLeftSidebar();
    this.bodyTag = this.document.body;
  }
  ngOnDestroy() {
    this.routerObj.unsubscribe();
    this.unsubscribe$.next(undefined);
    this.unsubscribe$.complete();
  }



  /** Si el archivo del logo no esta en el servidor, se usa la imagen por defecto. */
  usarImagenPorDefecto(){
    if (this.userImg !== SidebarComponent.IMAGEN_POR_DEFECTO) {
      this.userImg = SidebarComponent.IMAGEN_POR_DEFECTO;
    }
  }

  updateUrlImg(){
    /*this.userImg = "assets/images/user/admin.png";
    if (this.usuarioLogeado.getUsuario_cargo() == Role.CARGO_DOCTOR){
      this.userImg = "assets/images/user/doctorv2.jpg";
    }*/
    this.userImg = this.empresaObj?.empresa_urllogo;
    if (!this.userImg || this.userImg.trim() === ""){
      this.userImg = SidebarComponent.IMAGEN_POR_DEFECTO;
    }
  }

  /** Abre el manual en una ventana aparte para consultarlo con el sistema al lado. */
  abrirManual(event: Event) {
    const ancho = Math.min(1280, window.screen.availWidth - 80);
    const alto = Math.min(900, window.screen.availHeight - 80);
    const ventana = window.open(this.manualUrl, 'manualRRHH', 'resizable=yes,scrollbars=yes,width=' + ancho + ',height=' + alto);
    // si el navegador bloquea la ventana emergente, el enlace sigue su curso y abre una pestaña nueva
    if (ventana) {
      ventana.opener = null;
      event.preventDefault();
    }
  }

  initLeftSidebar() {
    const _this = this;
    // Set menu height
    _this.setMenuHeight();
    _this.checkStatuForResize(true);
  }
  setMenuHeight() {
    this.innerHeight = window.innerHeight;
    // se reserva el alto del enlace al manual, fijo al pie de la barra
    // la lista empieza 14px debajo de la cabecera (margen del menu)
    const height = this.innerHeight - this.headerHeight - this.manualHeight - 14;
    this.listMaxHeight = height + "";
    this.listMaxWidth = "500px";
  }
  isOpen() {
    return this.bodyTag.classList.contains("overlay-open");
  }
  checkStatuForResize(firstTime) {
    if (window.innerWidth < 1170) {
      this.renderer.addClass(this.document.body, "ls-closed");
    } else {
      this.renderer.removeClass(this.document.body, "ls-closed");
    }
  }
  mouseHover(e) {
    const body = this.elementRef.nativeElement.closest("body");
    if (body.classList.contains("submenu-closed")) {
      this.renderer.addClass(this.document.body, "side-closed-hover");
      this.renderer.removeClass(this.document.body, "submenu-closed");
    }
  }
  mouseOut(e) {
    const body = this.elementRef.nativeElement.closest("body");
    if (body.classList.contains("side-closed-hover")) {
      this.renderer.removeClass(this.document.body, "side-closed-hover");
      this.renderer.addClass(this.document.body, "submenu-closed");
    }
  }
}
